module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-a.jpg"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Editors#edi"
    }
  }, [_vm._v("Editors’ Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1"
    }
  }, [_vm._v("Photographing the War on the Water")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Chris Heisey")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2"
    }
  }, [_vm._v("The Civil War Naval Theaters Near and Far")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3"
    }
  }, [_vm._v("The U.S. Naval Academy: Coming of Age for Civil War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4"
    }
  }, [_vm._v("The Last Slaver: Voyage of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sheritta Bitikofer")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perpetual Beacons? Lighthouses and the Civil War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sarah Kay Bierle")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blockade, Privateering, and the 1856 Declaration of Paris")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Neil P. Chatelain")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Leathernecks of 1861")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Christopher L. Kolakowski")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Town Between the Rivers: Cairo, Illinois")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Dark Nights: Blockade Runners Supplying the Confederacy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sarah Kay Bierle")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fighting for California Gold on the Panamá Route")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Neil P. Chatelain")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gideon Welles and Gustavus Fox: Dynamic Duo of the Deep")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ships vs. Forts 1861: Off to the Races")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Civil War on the OBX: 1861’s Forgotten Story Gets New Attention")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Chris Mackowski")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rolling on the River: Civil War Brown-Water Navies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Stone Fleet: A Failure and Complete")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes and Caroline Davis")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailors and Slaves in the Civil War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pirates in Gray and Blue: The CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nashville")]), _vm._v(" and the Trent Affair")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burnside’s Sand March: The North Carolina Amphibious Expedition")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attrition Rates of City-Class Ironclads")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Neil P. Chatelain")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("View from the Ramparts: Fortress Monroe, Virginia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Around We Go in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monitor")]), _vm._v(" Turret")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Battle of Ironclads: Myths, Facts, What Ifs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunboats USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tyler")]), _vm._v(" and USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lexington")]), _vm._v(" at Shiloh")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sean Michael Chick")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dichotomy of Command Organizations at New Orleans")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Neil P. Chatelain")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Less Famous Lees of the Navy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Caroline Davis and Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Smalls and the Daring Capture of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Planter")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Scott L. Mingus Sr.")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Most Curious Battle: Memphis, Tennessee, June 6, 1862")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Volcano with the Ironclad CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arkansas")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailor and Artist: Robert W. Weir of the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richmond")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sheritta Bitikofer")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loss of the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monitor")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Chris Mackowski")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. First Mate’s Retribution")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Brian Swartz")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farragut vs. Port Hudson")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sean Michael Chick")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Perilous Voyage on the Kanawha: Jenkins Attacks "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victor No. 2")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Jon-Erik Gilot")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles (Savez) Read and the Battle of Portland Harbor")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Ryan Quint")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Civil War Submarine in the Little Free Library")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Meg Groeling")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederate Torpedoes Could Not Sink John Crosby for Long")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Brian Swartz")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blasting His Way into the History Books: Assessing the Role of Cmdr. Hunter Davidson")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("John M. Coski")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Very Essence of Nightmare”: The Battle of Plymouth, NC, and the Destruction of the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Albemarle")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Sam Smith")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buchanan at Mobile Bay")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("John V. Quarstein")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Most Profitable Ironclad: The Miniature Monitor That Raised Funds and Hope for the Union")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Jon-Erik Gilot 246")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilmington: The Last Open Port on the Confederate Coast")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Caroline Davis")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("World on Fire: Confederates on the Far Side")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ambitions of a European-Built Confederate Navy Squadron")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Neil P. Chatelain")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Having Done My Duty: Lowering the Last Rebel Banner")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Civil War Monuments on the Ocean")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_vm._v("Dwight Hughes")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Contributors#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors’ Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56_Postscript#pos",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1318eeb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0